export const environment = {
  production: false,
  baseUrl: 'https://main.dev.tapgo.ch/app/v1/',
  // baseUrl: 'https://api.app.tapgo.ch:8443/app/v1/',
  backupBaseUrl: 'https://main.dev.tapgo.ch/app/v1/',

  tenantApi: 'https://tenant.dev.tapgo.ch/app/v1/',
  backupTenantApi: 'https://tenant.dev.tapgo.ch/app/v1/',

  SPACE_NAME: 'demo-tap-go',
  S3_URL: 'https://sos-ch-dk-2.exo.io/demo-tap-go/',
  simulated: 0,
};
